import { render, staticRenderFns } from "./ArchiveEditForm.vue?vue&type=template&id=055411ee&"
import script from "./ArchiveEditForm.vue?vue&type=script&lang=js&"
export * from "./ArchiveEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveEditForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports